import React from 'react';
import { Helmet } from 'react-helmet-async';

// Defaults applied when a route doesn't override a given field.
const SITE_URL = 'https://vijaypages.com';
const DEFAULT_TITLE = 'Vijay Kagupati - Unity / XR Developer';
const DEFAULT_DESCRIPTION =
    "I build VR and MR experiences in Unity and study what makes people stay in them. Harvard XR 2025 winner. VR game with 80,000+ installs on the Meta Store.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * Per-route SEO tags: title, meta description, canonical URL, Open Graph, Twitter Card.
 *
 * Props:
 *   title       - page title (falls back to DEFAULT_TITLE)
 *   description - meta description (falls back to DEFAULT_DESCRIPTION)
 *   url         - canonical URL (defaults to SITE_URL)
 *   image       - OG image (absolute URL preferred; falls back to DEFAULT_IMAGE)
 *   noindex     - if true, emit robots: noindex,nofollow (e.g. for "not found" pages)
 */
function SEO({ title, description, url, image, noindex = false }) {
    const finalTitle = title || DEFAULT_TITLE;
    const finalDescription = description || DEFAULT_DESCRIPTION;
    const finalUrl = url || SITE_URL;
    const finalImage = image || DEFAULT_IMAGE;

    return (
        <Helmet>
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />
            <link rel="canonical" href={finalUrl} />
            {noindex && <meta name="robots" content="noindex, nofollow" />}

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:url" content={finalUrl} />
            <meta property="og:image" content={finalImage} />
            <meta property="og:site_name" content="Vijay Kagupati" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={finalImage} />
            <meta name="twitter:creator" content="@VijayKagupati" />
        </Helmet>
    );
}

export default SEO;
